var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRoundedCorner = function SvgRoundedCorner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M20.5 19.0001C20.5 13.0001 17 9.50012 11 9.50012"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.231,
    cy: 9.231,
    r: 1.731,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.769,
    cy: 20.769,
    r: 1.731,
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
};
export default SvgRoundedCorner;